import { Modal, Radio, RadioGroupProps } from "antd";
import classes from "./ChangeResponsibleManagerModal.module.css";
import { IChangeResponsibleManagerModalProps } from "../../../../interfaces/props/AdminManagerInfo/IChangeResponsibleManagerModalProps";

export const ChangeResponsibleManagerModal = ({
  managerList,
  activeManagerId,
  onChangeActiveManagerId,
  ...restModalProps
}: IChangeResponsibleManagerModalProps) => {
  const handleChange: RadioGroupProps["onChange"] = (e) => {
    if (typeof e.target.value === "number") {
      onChangeActiveManagerId(e.target.value);
    }
  };

  return (
    <Modal {...restModalProps}>
      <div className={classes.modalHeader}>
        Выберите ответственного менеджера
      </div>
      <div className={classes.managerListWrapper}>
        <Radio.Group onChange={handleChange} className={classes.managerList}>
          {managerList.map((el) => (
            <Radio className={classes.managerItem} key={el.id} value={el.id}>
              {el.fullName}
            </Radio>
          ))}
        </Radio.Group>
      </div>
    </Modal>
  );
};
